/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore'], function(backbone, _) {
    var SkuModel;

    return (SkuModel = backbone.Model.extend(
        {
            defaults: {
                id: null,
                quantity: 0,
                sides: 1,
                retailCost: 0.0,
                pricingSets: {},
                description: null,
                enabled: true,
                optionValueConflicts: []
            },

            /**
             * @param {Object} dto
             * @returns {SkuModel}
             */
            fromDTO: function(dto) {
                var _this = this;
                _.each(SkuModel.DTOMap, function(mappedName, attributeName) {
                    var value = dto[mappedName];
                    if (value !== undefined) {
                        _this.set(attributeName, value);
                    }
                });

                return this;
            },

            /**
             * @param {string} pricingSetName
             * @return {number}
             */
            getPrice: function(pricingSetName) {
                if (pricingSetName && this.get('pricingSets') && this.get('pricingSets')[pricingSetName]) {
                    return parseFloat(this.get('pricingSets')[pricingSetName]);
                }

                return this.get('retailCost');
            }
        },
        {
            DTOMap: {
                id: 'id',
                quantity: 'quantity',
                sides: 'sides',
                retailCost: 'retail_cost',
                pricingSets: 'pricing_sets',
                description: 'description',
                weight: 'weight',
                enabled: 'enabled',
                optionValueConflicts: 'option_value_conflicts_with'
            }
        }
    ));
});
